import React from 'react';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MuiDialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';

const DialogActions = (props) => (
  <MuiDialogActions
    {...props}
    sx={(theme) => ({ borderTop: `1px solid ${theme.palette.divider}` })}
  />
);

const AlertModal = (props) => {
  const {
    open,
    title,
    text,
    additionalText,
    onSubmit,
    onClose,
    submitText,
    closeText,
  } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: { width: '450px' },
      }}
    >
      {title && (
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: 'center' }}
        >
          {title}
        </DialogTitle>
      )}

      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          style={{ textAlign: 'center' }}
        >
          {text}
        </DialogContentText>

        {additionalText && (
          <DialogContentText
            id="alert-dialog-description"
            style={{ textAlign: 'center' }}
          >
            {additionalText}
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions>
        <div className="d-flex flex-1">
          <Box
            className="flex-1 p-md text-center secondary pointer font-bold"
            sx={(theme) => ({ borderRight: `1px solid ${theme.palette.divider}` })}
            onClick={onClose}
          >
            {closeText || 'Back'}
          </Box>

          <div
            className="flex-1 p-md text-center pointer font-bold"
            style={{ color: '#1976d2' }} // identical to theme primary in practice
            onClick={onSubmit}
          >
            {submitText || 'Confirm'}
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
};

AlertModal.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  text: PropTypes.string,
  submitText: PropTypes.string,
  closeText: PropTypes.string,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

export default AlertModal;
